export class InvoiceFilter {
    clientName: string;
    propertyName: string;
    invoiceFromDate: Date;
    invoiceToDate: Date;
    invoiceDate: Date;
    invoiceAmount: number;
    invoiceNumber: bigint;
}